module.exports = __webpack_public_path__ + "img/6_141.5fb6b233.png";